import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { errorHelper } from '../../utils/tools';
import { formValues, validation } from './validationSchema';

import { Form, Row, Col, Button } from 'react-bootstrap';

import { addBranch, fetchBranches } from '../../store/actions/branch';
import { getTenant } from '../../store/actions/tenant';

const AddBranch = ({onClose}) => {
    const notifications = useSelector(state => state.notifications);
    const currentBranch = useSelector(state => state.branch.current);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const formik = useFormik({
        initialValues: formValues,
        validationSchema: validation,
        onSubmit: (values) => {
            handleSubmit(values);
        },
        validateOnChange: true,
        validateOnBlur: true,
    });

    // Reset form on success notification
    useEffect(() => {
        if (notifications && notifications.global.success) {
            formik.resetForm();
            dispatch(getTenant(currentBranch));
            onClose();
        }
    }, [notifications, formik]);

    const handleSubmit = (values) => {
        
         // Send data
         dispatch(addBranch(values))
         .then(() => {
             if (currentBranch !== '') {
                 dispatch(fetchBranches(currentBranch));
             }
             navigate(`/branch/`);
         })
         .catch(error => {
             console.error("Error adding branch:", error);
         });
    };

 

    return (
        <Form onSubmit={formik.handleSubmit}>
            <h2>Pridať prevádzku</h2>
            <hr />

             <Row>

                <Form.Group className="mb-3" controlId="formBasicName">
                    <Form.Label>Názov prevádzky</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Názov prevádzky:"
                        {...formik.getFieldProps('name')}
                        isInvalid={formik.touched.name && formik.errors.name}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'name').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicContact">
                    <Form.Label>Mobil</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Mobil:"
                        {...formik.getFieldProps('contact')}
                        isInvalid={formik.touched.contact && formik.errors.contact}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'contact').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicStreet">
                    <Form.Label>Ulica</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ulica:"
                        {...formik.getFieldProps('street')}
                        isInvalid={formik.touched.street && formik.errors.street}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'street').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicBuildingNumber">
                    <Form.Label>Orientačné číslo</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Orientačné číslo:"
                        {...formik.getFieldProps('buildingNumber')}
                        isInvalid={formik.touched.buildingNumber && formik.errors.buildingNumber}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'buildingNumber').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicRegistrationNumber">
                    <Form.Label>Súpisné číslo</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Súpisné číslo:"
                        {...formik.getFieldProps('registrationNumber')}
                        isInvalid={formik.touched.registrationNumber && formik.errors.registrationNumber}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'registrationNumber').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicZip">
                    <Form.Label>PSČ</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="PSČ:"
                        {...formik.getFieldProps('zip')}
                        isInvalid={formik.touched.zip && formik.errors.zip}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'zip').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicCity">
                    <Form.Label>Mesto</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Mesto:"
                        {...formik.getFieldProps('city')}
                        isInvalid={formik.touched.city && formik.errors.city}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'city').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicResponsiblePerson">
                    <Form.Label>Zodpovedná osoba (meno a priezvisko)</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Meno a priezvisko:"
                        {...formik.getFieldProps('responsiblePerson')}
                        isInvalid={formik.touched.responsiblePerson && formik.errors.responsiblePerson}
                    />
                    <Form.Control.Feedback type="invalid">
                         {errorHelper(formik, 'responsiblePerson').helperText}
                    </Form.Control.Feedback>
                </Form.Group>

            </Row>

            <Row className="mt-auto">
                <hr />
                <Col className="d-flex justify-content-end">
                    <Button 
                        className='button-custom-large' 
                        variant='primary' 
                        type="submit" 
                        size="lg" 
                        style={{ marginTop: 'auto' }}
                    >
                        Pridať prevádzku
                    </Button>
                </Col>
            </Row>

        </Form>
    );
};

export default AddBranch;